import { useCallback, useMemo } from "react";

import { getInitialValues } from "components/Forms/helpers/getInitialValues";
import { showToast } from "components/Toasts/helpers/showToast";
import AgreementForm from "features/agreements2/components/Agreement/AgreementForm";
import { useAgreementContext } from "features/agreements2/components/Agreement/context/AgreementContext";
import { agreementFieldDefs } from "features/agreements2/constants/agreementFieldDefs";
import { getChangedValues } from "helpers/getChangedValues";

import useAgreementCreate from "./hooks/useAgreementCreate";

// Form for creating and editing agreements
const CreateAgreementForm = ({ children }) => {
  const { assignmentId, creatorId, setAgreementId } = useAgreementContext();
  const { createAgreement } = useAgreementCreate();

  const initialValues = useMemo(
    () => getInitialValues(agreementFieldDefs, {}),
    [],
  );

  const onSubmit = useCallback(
    async(values, actions) => {
      try {
        // create
        const submitValues = getChangedValues(values, initialValues);
        if (creatorId) {
          submitValues.user_id = creatorId;
        }
        if (assignmentId) {
          submitValues.assignment_id = assignmentId;
        }
        // Remove signature-related fields for off-platform agreements (per API: ignored if signedOffPlatform is true)
        if (values?.signedOffPlatform) {
          delete submitValues.requiresCreatorSignature;
          delete submitValues.requiresAdminSignature;
          delete submitValues.adminSigner_id;
          delete submitValues.creatorHasSigned;
          delete submitValues.adminHasSigned;
        }
        // if (values?.requiresAdminSignature && !submitValues.adminSigner_id) {
        //   submitValues.adminSigner_id = loggedInUser?._id;
        // }
        const { result, error } = await createAgreement(submitValues).unwrap();
        if (error) throw new Error(error);
        // setAgreementUIStatus("closed");
        actions.setSubmitting(false);
        showToast({
          type: "success",
          message: values?.signedOffPlatform
            ? "Off-platform Agreement uploaded successfully"
            : "Draft Agreement created successfully",
        });
        setAgreementId(result?._id);
      } catch (error) {
        console.error("Error saving agreement - ", error);
        showToast({
          type: "error",
          message: "Error saving agreement",
        });
      }
    },
    [assignmentId, createAgreement, creatorId, initialValues, setAgreementId],
  );
  return (
    <AgreementForm initialValues={initialValues} onSubmit={onSubmit}>
      {children}
    </AgreementForm>
  );
};

export default CreateAgreementForm;
